export const claimUpdatesMonthlyContent = {
  lastUpdated: 'September 2026',
  claimUpdate: {
    heading: 'Your Claim Update',
    body: [
      "We're continuing to manage your car finance claim and wanted to keep you updated on the latest developments.",
      "Your claim remains active and there's nothing you need to do at this stage. While the industry awaits the outcome of the legal challenge to the FCA compensation scheme, our team is continuing the work needed to keep your claim in the best position to progress.",
    ],
  },

  latestIndustryNews: {
    heading: 'Latest industry update',
    body: [
      "The FCA's Motor Finance Consumer Redress Scheme is currently subject to legal challenges, and parts of the scheme have been temporarily suspended while these are considered.",
      'The Upper Tribunal is due to hear the challenges either 14–18 December 2026 or 16–26 February 2027, depending on how the proceedings develop.',
      'While the legal process continues, lenders are not currently required to calculate or pay compensation under the scheme. However, they can continue preparing for the scheme and progressing complaints as far as possible.',
      "For you, this simply means that your claim remains with us and we'll continue managing it while the legal process progresses.",
    ],
  },

  whatThisMeansForYou: {
    heading: 'What this means for your claim',
    body: [
      'There is nothing you need to do at this stage.',
      "We'll continue to manage your claim, deal with lender communications and monitor developments closely. Our focus is on making sure your claim is properly prepared and ready to progress when lenders are required to move forward under the scheme.",
      "We'll contact you directly if we need anything from you or when there is an important update.",
    ],
  },

  stayingInformed: {
    heading: 'Keeping you informed',
    body: [
      "We'll continue to keep you updated as your claim progresses and when there are important developments.",
      'If your personal details have changed, please let us know by emailing info@yourclaimmatters.co.uk, quoting your Reference Number.',
      "Thank you for choosing Your Claim Matters to represent you. We're continuing to actively manage your claim and will keep you informed every step of the way.",
    ],
  },

  newThisMonth: {
    month: 'September 2026',
    headline: 'Upper Tribunal to hear legal challenges',
    summary:
      "The Upper Tribunal is expected to hear the legal challenges to the FCA's motor finance compensation scheme either in December 2026 or February 2027.",
    sourceUrl:
      'https://www.fca.org.uk/news/statements/motor-finance-scheme-partially-suspended',
  },
}
